<header>
    <nav
        class="relative"
        [ngClass]="{
        'bg-white': !entity?.darkMode,
        'bg-gray-950': entity?.darkMode,
        'text-white': entity?.darkMode,
        'text-gray-900': !entity?.darkMode,
    }"
        aria-label="Navigation">
        <app-component-overlay *ngIf="editMode" [editMode]="editMode" [isHeader]="true"></app-component-overlay>
        <div
            class="mx-auto flex max-w-7xl items-center py-3 lg:py-6 px-2 lg:gap-x-12"
            [ngClass]="{ 'lg:container': !fullWidthLayout }">
            <div class="flex flex-1" [ngClass]="{ 'lg:flex-initial': entity?.centerMenu }">
                <a [target]="logoLinkTarget" [href]="logoLink" class="-m-1.5 p-1.5">
                    <span class="sr-only">{{ client?.name }}</span>
                    <img class="h-12 lg:h-16 w-auto" [src]="logoImg" [alt]="client?.name + ' logo'" [height]="mobileMode ? '48px' : '64px'" />
                </a>
            </div>
            <div *ngIf="entity?.showHeaderLinks !== false" class="flex lg:hidden">
                <button
                    (click)="toggleMenu()"
                    type="button"
                    [ngClass]="{
                        'text-gray-700': !entity?.darkMode,
                        'text-white': entity?.darkMode,
                    }"
                    class="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 bg-transparent border-transparent">
                    <span class="sr-only">Open main menu</span>
                    <svg
                        class="h-6 w-6"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        aria-hidden="true">
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
                    </svg>
                </button>
            </div>
            <div
                *ngIf="entity?.showHeaderLinks !== false"
                class="hidden lg:flex lg:gap-x-12"
                [ngClass]="{ 'lg:flex-1 justify-center': entity?.centerMenu }">
                <div class="flex gap-4" *ngFor="let page of menuConfig?.top">
                    <div class="relative group">
                        <a
                            [class.disabled]="editMode"
                            *ngIf="page.slug"
                            (click)="navigateWithHash(page.slug, page.hashFragment); $event.preventDefault()"
                            routerLinkActive="active"
                            [routerLinkActiveOptions]="{ exact: true }"
                            class="text-base font-bold leading-6 hover:underline underline-offset-8 flex items-center cursor-pointer"
                            i18n
                            [ngClass]="{
                                'text-gray-900': !entity?.darkMode,
                                'text-white': entity?.darkMode,
                            }"
                            >{{ page.default ? "Home" : page.title }}
                        </a>
                        <a
                            [class.disabled]="editMode"
                            *ngIf="page.url"
                            [href]="page.url"
                            class="text-base font-bold leading-6 hover:underline underline-offset-8 flex items-center"
                            [ngClass]="{
                                'text-gray-900': !entity?.darkMode,
                                'text-white': entity?.darkMode,
                            }"
                            >{{ page.title }}
                            <span *ngIf="page.subItems?.length" class="mat-icon font-normal ml-1">expand_more</span>
                            <span class="mat-icon font-normal">open_in_new</span>
                        </a>

                        <!-- Sub-menu dropdown -->
                        <div *ngIf="page.subItems?.length"
                             class="absolute left-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 hidden group-hover:block z-50 transition-all duration-200 ease-in-out"
                             [ngClass]="{
                                'bg-white': !entity?.darkMode,
                                'bg-gray-950': entity?.darkMode,
                                'text-white': entity?.darkMode,
                                'text-gray-900': !entity?.darkMode,
                             }">
                            <!-- Invisible hover area to prevent accidental closure -->
                            <div class="absolute -top-4 left-0 w-full h-4"></div>
                            <div class="relative">
                                <ng-container *ngFor="let subItem of page.subItems">
                                    <a *ngIf="subItem.slug"
                                       (click)="navigateWithHash(subItem.slug, subItem.hashFragment); $event.preventDefault()"
                                       routerLinkActive="active"
                                       class="block px-4 py-2 text-sm hover:bg-gray-100 cursor-pointer transition-colors duration-150"
                                       [ngClass]="{
                                           'hover:bg-gray-100': !entity?.darkMode,
                                           'hover:bg-gray-800': entity?.darkMode
                                       }">
                                        {{ subItem.title }}
                                    </a>
                                    <a *ngIf="subItem.url"
                                       [href]="subItem.url"
                                       class="block px-4 py-2 text-sm hover:bg-gray-100 transition-colors duration-150"
                                       [ngClass]="{
                                           'hover:bg-gray-100': !entity?.darkMode,
                                           'hover:bg-gray-800': entity?.darkMode
                                       }">
                                        {{ subItem.title }}
                                    </a>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="entity?.quickSearch" class="hidden lg:flex">
                <ng-container *ngTemplateOutlet="searchInput"></ng-container>
            </div>
            <div *ngIf="entity?.showLocalePicker" class="hidden lg:flex">
                <app-locale-picker></app-locale-picker>
            </div>
        </div>
    </nav>
    <div *ngIf="!closed" class="lg:hidden" role="dialog" aria-modal="true">
        <!-- Background backdrop, show/hide based on slide-over state. -->
        <div class="fixed inset-0 z-40"></div>
        <div
            class="fixed inset-y-0 right-0 z-40 w-full overflow-y-auto sm:max-w-sm sm:ring-1 sm:ring-gray-900/10"
            [ngClass]="{
                'bg-white': !entity?.darkMode,
                'bg-gray-950': entity?.darkMode,
                'text-white': entity?.darkMode,
                'text-gray-900': !entity?.darkMode,
            }">
            <div class="flex items-center justify-between px-2 py-3">
                <a [target]="logoLinkTarget" [href]="logoLink" class="-m-1.5 p-1.5">
                    <span class="sr-only">{{ client?.name }}</span>
                    <img
                        class="h-12 lg:h-16 w-auto"
                        [src]="logoImg"
                        [alt]="client?.name" />
                </a>
                <button
                    (click)="toggleMenu()"
                    type="button"
                    class="-m-2.5 rounded-md p-2.5 bg-transparent border-transparent">
                    <span class="sr-only">Close menu</span>
                    <svg
                        class="h-6 w-6"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        aria-hidden="true">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
            </div>
            <div class="mt-6 flow-root px-6 py-6">
                <div class="-my-6 divide-y divide-gray-500/10">
                    <div class="space-y-2 py-6">
                        <ng-container *ngFor="let page of menuConfig?.top">
                            <div class="space-y-2">
                                <a
                                    [class.disabled]="editMode"
                                    *ngIf="page.slug"
                                    (click)="navigateWithHash(page.slug, page.hashFragment); $event.preventDefault()"
                                    routerLinkActive="active"
                                    [routerLinkActiveOptions]="{ exact: true }"
                                    class="-mx-3 block rounded-lg px-3 py-2 text-base font-bold leading-7 hover:underline underline-offset-8"
                                    i18n
                                    >{{ page.default ? "Home" : page.title }}</a
                                >
                                <a
                                    [class.disabled]="editMode"
                                    *ngIf="page.url"
                                    [href]="page.url"
                                    target="_blank"
                                    class="-mx-3 block rounded-lg px-3 py-2 text-base font-bold leading-7 hover:underline underline-offset-8"
                                    >{{ page.title }} <span class="mat-icon font-normal">open_in_new</span></a
                                >

                                <!-- Mobile sub-menu items -->
                                <div *ngIf="page.subItems?.length" class="pl-4 space-y-2">
                                    <ng-container *ngFor="let subItem of page.subItems">
                                        <a *ngIf="subItem.slug"
                                           (click)="navigateWithHash(subItem.slug, subItem.hashFragment); $event.preventDefault()"
                                           routerLinkActive="active"
                                           class="block rounded-lg px-3 py-2 text-sm font-medium hover:underline underline-offset-8">
                                            {{ subItem.title }}
                                        </a>
                                        <a *ngIf="subItem.url"
                                           [href]="subItem.url"
                                           target="_blank"
                                           class="block rounded-lg px-3 py-2 text-sm font-medium hover:underline underline-offset-8">
                                            {{ subItem.title }}
                                        </a>
                                    </ng-container>
                                </div>
                            </div>
                        </ng-container>

                        <div class="-mx-3 block rounded-lg px-3 py-2" *ngIf="entity?.showLocalePicker">
                            <app-locale-picker (localePickerOpened)="toggleMenu()"></app-locale-picker>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</header>

<ng-template #searchInput>
    <div class="w-full">
        <label for="quickSearchKeywords" class="sr-only" aria-label="Search Jobs" i18n>Search Jobs</label>
        <div class="relative">
            <button
                aria-label="Search Jobs"
                i18n
                class="cursor-pointer absolute inset-y-0 left-0 rounded-full hover:bg-gray-100 flex items-center px-3"
                (click)="quickSearch()">
                <svg
                    [ngClass]="{
                        'text-gray-100': entity.darkMode,
                        'text-gray-900': !entity.darkMode,
                    }"
                    class="h-5 w-5"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true"
                    aria-label="Search icon">
                    <path
                        fill-rule="evenodd"
                        d="M9 3.5a5.5 5.5 0 100 11 5.5 5.5 0 000-11zM2 9a7 7 0 1112.452 4.391l3.328 3.329a.75.75 0 11-1.06 1.06l-3.329-3.328A7 7 0 012 9z"
                        clip-rule="evenodd" />
                </svg>
            </button>
            <input
                id="quickSearchKeywords"
                [(ngModel)]="keywords"
                i18n
                i18n-placeholder
                placeholder="Search Jobs"
                class="block w-full h-10 rounded-md border-0 pl-12 p-2 sm:text-sm sm:leading-6 outline-none"
                [ngClass]="{
                    'text-gray-100 bg-transparent placeholder:text-white': entity.darkMode,
                    'text-gray-900 placeholder:text-black': !entity.darkMode,
                }" />
        </div>
    </div>
</ng-template>
